<template>
  <div
    class="BaseButton"
    :class="[{ 'is-icon': icon }, { 'is-round': round }]"
    @click="$emit('click')"
  >
    <span>
      <slot></slot>
    </span>
  </div>
</template>
<script>
export default {
  name: 'BaseButton',
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: Boolean,
    round: Boolean,
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.BaseButton {
  color: color(white);
  padding: 10px 25px;
  position: relative;
  background-color: color(orange);
  display: inline-block;
  cursor: pointer;
  transition: all 0.195s $ease;

  &.is-round {
    border-radius: 48%;
    padding: 0;
    position: relative;
  }

  &.is-icon {
    width: 20px;
    height: 20px;
    padding: 0px;
    box-sizing: content-box;
    display: inline-block;
    width: unset;
    height: unset;

    svg {
      width: 20px;
      height: 20px;
      padding: 17px;
      display: block;
      box-sizing: content-box;
    }
  }

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }
}
</style>
